
import React from 'react';
import { Users, Loader2 } from 'lucide-react';
import UserCard from './UserCard';
import { useInfiniteScroll } from '@/hooks/useInfiniteScroll';

interface UsersListProps {
  users: any[];
  currentUserIsAdmin: boolean;
  onViewProfile: (username: string) => void;
  
  onUserAction: (action: string, userId: string) => void;
  onResetAccount: (user: any) => void;
  onManageRole?: (user: any) => void;
  loadMoreUsers?: () => void;
  hasMoreUsers?: boolean;
  loadingMore?: boolean;
}

const UsersList: React.FC<UsersListProps> = ({
  users,
  currentUserIsAdmin,
  onViewProfile,
  
  onUserAction,
  onResetAccount,
  onManageRole,
  loadMoreUsers,
  hasMoreUsers = false,
  loadingMore = false
}) => {
  const { observerTarget } = useInfiniteScroll({
    onLoadMore: loadMoreUsers || (() => {}),
    hasMore: hasMoreUsers,
    isLoading: loadingMore,
    threshold: 300
  });

  if (users.length === 0) {
    return (
      <div className="text-center py-12">
        <Users className="h-12 w-12 text-white/40 mx-auto mb-4" />
        <p className="text-white/60">Nenhum usuário encontrado</p>
      </div>
    );
  }

  return (
    <div className="space-y-3">
      {users.map((user) => (
        <UserCard
          key={user.id}
          user={user}
          currentUserIsAdmin={currentUserIsAdmin}
          onViewProfile={onViewProfile}
          
          onUserAction={onUserAction}
          onResetAccount={onResetAccount}
          onManageRole={onManageRole}
        />
      ))}
      
      {/* Infinite scroll observer */}
      {loadMoreUsers && (
        <div ref={observerTarget} className="py-6 flex justify-center">
          {hasMoreUsers && loadingMore && (
            <div className="flex items-center gap-2 text-white/60">
              <Loader2 className="h-5 w-5 animate-spin" />
              <span>Carregando mais usuários...</span>
            </div>
          )}
          {!hasMoreUsers && users.length > 0 && (
            <p className="text-white/40 text-sm">Todos os usuários foram carregados</p>
          )}
        </div>
      )}
    </div>
  );
};

export default UsersList;
